import { Component, OnInit, Input, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ErrCrrUtility, patterns } from '../../err-crr-utility';

@Component({
    selector: 'app-error-crr-claim-ref',
    templateUrl: './error-crr-claim-ref.component.html',
    styleUrls: ['./error-crr-claim-ref.component.css'],
    standalone: false
})
export class ErrorCrrClaimRefComponent extends ErrCrrUtility implements OnInit,AfterViewInit {
  @Output() public collapseClaimRefInfoFields = new EventEmitter<any>();
  @Input() inputLabel;
  @Input() inputValue;
  @Input() isInstitutional: boolean;
  @Input() claimReferenceDesMapping;
  @Input() changeBtnCls: string;
  @Input() isServiceLineCategory:boolean;
  @Input() listData: any;
  public claimRefInfoForm;
  public maxLength = "50";
  viewLoaded :boolean;
  qualifierOptions = [];
  institutionalQualifiers = [{value:'4N' , label:'4N-Special Payment Reference Number'},
    {value:'9F' , label:'9F-Referral Number'},
    {value:'G1' , label:'G1-Prior Authorization Number'},
    {value:'F8' , label:'F8-Original Reference Number'},
    {value:'9A' , label:'9A-Repriced Claim Reference Number'},
    {value:'LX' , label:'LX-Qualified Products List'},
    {value:'D9' , label:'D9-Claim Number'},
    {value:'LU' , label:'LU-Location Number'},
    {value:'EA' , label:'EA-Medical Record Identification Number'},
    {value:'P4' , label:'P4-Project Code'},
    {value:'G4' , label:'G4-Peer Review Organization (PRO) Approval Number'},
    {value:'9C' , label:'9C-Adjusted Repriced Claim Reference Number'},
    ];

  professionalQualifiers = [{value:'4N' , label:'4N-Special Payment Reference Number'},
    {value:'F5', label:'F5-Medicare Version Code'},
    {value:'EW', label:'EW-Mammography Certification Number'},
    {value:'9F', label:'9F-Referral Number'},
    {value:'G1', label:'G1-Prior Authorization Number'},
    {value:'F8', label:'F8-Original Reference Number'},
    {value:'X4', label:'X4-Clinical Laboratory Improvement Amendment Number'},
    {value:'9A' , label:'9A-Repriced Claim Reference Number'},
    {value:'9C' , label:'9C-Adjusted Repriced Claim Reference Number'},
    {value:'LX' , label:'LX-Qualified Products List'},
    {value:'D9' , label:'D9-Claim Number'},
    {value:'EA' , label:'EA-Medical Record Identification Number'},
    {value:'P4' , label:'P4-Project Code'},
    {value:'1J' , label:'1J-Facility ID Number' }];

  public readonly maxLengthMapping = {
    "6R":"30",
    "EW":"6",
    "X4":"10",
    "F4":"10",
    "D9":"20",
    "1J":"10"
  }
  public readonly minLengthMapping = {
    "X4":"10",
    "F4":"10",
    "EW":"6"
  }
  public readonly ptternMapping = {
    "EW":"NUM",
    "X4":"AN3D",
    "F4":"AN3D",
    "1J":"AN11"

  }
  constructor(sanitized: DomSanitizer) { 
    super(sanitized)
  }

  ngOnInit() {
    this.qualifierOptions  = this.isInstitutional ? this.institutionalQualifiers : this.professionalQualifiers;
    this.initializeForm();
  }

  ngAfterViewInit(){
    this.viewLoaded = true;
  }

  cancelClick() {
    const event = {
      type: 'cancel',
      field: this.inputLabel
    }
    this.collapseClaimRefInfoFields.emit(event);
  }

  initializeForm() {
    let patternType = "AN";
    let minLength = "";
    this.maxLength = this.maxLengthMapping[this.inputValue.referenceIdentQual] || "50";
    patternType = this.ptternMapping[this.inputValue.referenceIdentQual] || "AN";
    minLength = this.minLengthMapping[this.inputValue.referenceIdentQual] || "";
    
    const formCtrls: any = {
      // Add the qualifier form control that was missing
      referenceIdentQual: new UntypedFormControl(
        this.qualifierOptions.find(q => q.value === this.inputValue.referenceIdentQual) ?? null, 
        [Validators.required]
      )
    }
    
    if (this.isLUReferenceIdentQual()) {
      formCtrls["state"] = new UntypedFormControl('', [this.getValidators("", "", true, "")])
    } else {
      formCtrls["refIdentification"] = new UntypedFormControl('', [this.getValidators(this.maxLength, patterns[patternType], true, minLength)]);
    }
    
    this.claimRefInfoForm = new UntypedFormGroup(formCtrls);
    
    if(this.isLUReferenceIdentQual()){
      if(this.listData && this.listData['state']) {
        this.listData['state'].forEach((element, index) => {
          if (this.inputValue.referenceIdent === element.value) {
           this.claimRefInfoForm.controls.state.setValue(this.listData['state'][index]);
          }
        })
      }
    }else{
      this.claimRefInfoForm.controls.refIdentification.setValue(this.inputValue.referenceIdent);
    }
  }

  getValidators(maxLength, pattern, required?, minLength?) {
    const validators: ValidatorFn[] = [];
    if (required) {
      validators.push(Validators.required);
    }
    if (minLength !== undefined) {
      validators.push(Validators.minLength(minLength));
    }
    if (maxLength) {
      validators.push(Validators.maxLength(maxLength));
    }
    if (pattern) {
      validators.push(Validators.pattern(pattern));
    }
    return Validators.compose(validators);
  }
  // validate() {
  //   const event = {
  //     type: 'validation',
  //     isInvalid: this.claimRefInfoForm.status === "INVALID",
  //     field: this.inputLabel
  //   }
  //   if(this.isLUReferenceIdentQual()){
  //     event['refIdentification'] = this.claimRefInfoForm.controls.state.status === 'INVALID';
  //   }else{
  //     event['refIdentification'] = this.claimRefInfoForm.controls.refIdentification.status === 'INVALID';
  //   }
  //   this.collapseClaimRefInfoFields.emit(event);
  // }

  validate() {
    const event = {
      type: 'validation',
      isInvalid: this.claimRefInfoForm.status === "INVALID",
      field: this.inputLabel,
      qualifier: false,
      refIdentification: false
    }
    
    this.validateFields(event);
    this.collapseClaimRefInfoFields.emit(event);
  }

  validateFields(event) {
    event['qualifier'] = this.claimRefInfoForm.controls.referenceIdentQual.status === 'INVALID';
    
    if(this.isLUReferenceIdentQual()){
      event['refIdentification'] = this.claimRefInfoForm.controls.state.status === 'INVALID';
    }else{
      event['refIdentification'] = this.claimRefInfoForm.controls.refIdentification.status === 'INVALID';
    }
  }


  // changeClick() {
  //   const event = {
  //     type: 'change',
  //     value: this.inputValue,
  //     field: this.inputLabel,
  //     isInvalid: false
  //   }
  //   event.isInvalid = this.claimRefInfoForm.status === "INVALID";
  //   if (!event.isInvalid) {
  //     this.inputValue.referenceIdent = this.isLUReferenceIdentQual() ? (this.claimRefInfoForm.get('state').value).value :this.claimRefInfoForm.get('refIdentification').value;
  //     event.value = this.inputValue;
  //   } else {
  //     if(this.isLUReferenceIdentQual()){
  //       event['refIdentification'] = this.claimRefInfoForm.controls.state.status === 'INVALID';
  //     } else{
  //       event['refIdentification'] = this.claimRefInfoForm.controls.refIdentification.status === 'INVALID';
  //     }
  //   }
  //   this.collapseClaimRefInfoFields.emit(event);
  // }

  changeClick() {
    const event = {
      type: 'change',
      value: this.inputValue,
      field: this.inputLabel,
      isInvalid: false
    }
    
    event.isInvalid = this.claimRefInfoForm.status === "INVALID";
    
    if (!event.isInvalid) {
      const selectedQualifier = this.claimRefInfoForm.get('referenceIdentQual').value;
      this.inputValue.referenceIdentQual = selectedQualifier ? selectedQualifier.value : '';
      this.inputValue.referenceIdent = this.isLUReferenceIdentQual() ? 
        (this.claimRefInfoForm.get('state').value).value : 
        this.claimRefInfoForm.get('refIdentification').value;
      event.value = this.inputValue;
    } else {
      this.validateFields(event);
    }
    
    this.collapseClaimRefInfoFields.emit(event);
  }

  mousedownEvent(event) {
    event.preventDefault();
  }

  isLUReferenceIdentQual(){
    const selectedQualifier = this.claimRefInfoForm?.get('referenceIdentQual')?.value;
    const qualifierValue = selectedQualifier ? selectedQualifier.value : this.inputValue.referenceIdentQual;
    return qualifierValue === 'LU';
  }

  // getFormControlValidity(frmControlNm) {
  //   let isInvalid: boolean = false;
  //   isInvalid = this.claimRefInfoForm.controls[frmControlNm].status === "INVALID";
  //   if (isInvalid && !this.viewLoaded) {
  //     this.validate();
  //   }
  //   return isInvalid;
  // }
  getFormControlValidity(frmControlNm) {
    let isInvalid: boolean = false;
    if (this.claimRefInfoForm && this.claimRefInfoForm.controls[frmControlNm]) {
      isInvalid = this.claimRefInfoForm.controls[frmControlNm].status === "INVALID";
      if (isInvalid && !this.viewLoaded) {
        this.validate();
      }
    }
    return isInvalid;
  }
}
